import React, { useMemo } from 'react';
import { Text, TextSize } from '@televet/kibble-ui/build/components/Text';
import { getAttachmentPreviewLabel } from 'pages/Conversations/utils';
import { ChannelListChannelLastMessageFragment } from 'shared/types/graphql';
import { TypographyVariant } from '@televet/kibble-ui/build/shared/types';

interface CardMessageProps {
  lastChannelMessage?: ChannelListChannelLastMessageFragment | null;
  channelId: string;
}

const staticTextProps: {
  isTruncated: boolean;
  size: TextSize;
  variant: TypographyVariant;
} = {
  isTruncated: true,
  size: 'sm',
  variant: 'subtle',
};

const CardMessage = ({ lastChannelMessage, channelId }: CardMessageProps): JSX.Element => {
  const textProps = useMemo(
    () => ({
      ...staticTextProps,
      ['data-testid']: `channellistitem-${channelId}-message-${lastChannelMessage?.index}`,
    }),
    [lastChannelMessage, channelId],
  );

  if (!lastChannelMessage) return <></>;

  if (lastChannelMessage.deletedAt)
    return (
      <Text className="ChannelListItem__Message--Unavailable" {...textProps} fontStyle="italic">
        This message is no longer available.
      </Text>
    );

  if (!lastChannelMessage.body && lastChannelMessage.attachments?.length) {
    const [attachment] = lastChannelMessage.attachments;
    return (
      <Text className="ChannelListItem__Message--Attachment" {...textProps} fontStyle="italic">
        {getAttachmentPreviewLabel(attachment.attachmentType)}
      </Text>
    );
  }

  return (
    <Text className="ChannelListItem__Message--Text" {...textProps} variant="default">
      {lastChannelMessage.body || ''}
    </Text>
  );
};

export default CardMessage;
